import React from "react";
import { useState } from "react";
import { Button, Col } from "reactstrap";
import { Icon } from "../Component";

const DropSelectButton = ({ options, onChange, children, onClick, disabled }) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <Col md="3" className="d-flex justify-content-end">
        <Button color="primary" className="" onClick={onClick} disabled={disabled}>
          {children}
        </Button>
        <Col
          md="1"
          onClick={() => setShow((prev) => !prev)}
          className="bg-primary ml-1 d-flex align-items-center justify-content-center rounded text-white"
          style={{ cursor: "pointer" }}
        >
          <Icon name="chevron-down" />
        </Col>
        {show && (
          <div
            className="bg-white rounded p-3"
            style={{ position: "absolute", right: 0, width: "50%", top: "110%", zIndex: "4" }}
          >
            {options.map((opt) => (
              <div
                onClick={() => {
                  setShow(false);
                  onChange(opt);
                }}
                className="p-1 border-bottom"
                style={{ cursor: "pointer" }}
              >
                {opt}
              </div>
            ))}
          </div>
        )}
      </Col>
    </>
  );
};

export default DropSelectButton;
